import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/functions"
import "firebase/compat/storage"
import "util-functions/init"

firebase.app()

const firestore = firebase.firestore()
const functions = firebase.functions()
const auth = firebase.auth()
// export { auth, firebase, firestore, googleAuthProvider, storage, analytics, functions, firestore as default }
export { auth, firestore as default, firebase, functions }
